/**
 * Does this string actually start with HTML?
 *
 * Deliberately a tag-name whitelist rather than a bare `startsWith('<')`.
 * Answer payloads routinely begin with a `<` that is not HTML at all — leaked
 * agent scaffolding (`<function_calls>`), or plain prose (`<10 tickets open`).
 * Routing those through `dangerouslySetInnerHTML` + DOMPurify strips the
 * pseudo-tags, collapses every newline (HTML whitespace collapse), and kills
 * markdown entirely — a GFM table degrades into one line of literal `|` pipes.
 *
 * The `\b` after each name is what does the work: `<div`, `<div>` and
 * `<table ` match, while `<function_calls>` and `<a_b>` do not (`_` is a word
 * character, so there is no boundary after the whitelisted name).
 *
 * @param {*} str - candidate string (non-strings are never HTML)
 * @returns {boolean}
 */
// `link` is deliberately NOT whitelisted even though it's real HTML:
// key_insights uses <link>...</link> as a PSEUDO-tag that responseParser
// rewrites to backticks for markdown — routing it to innerHTML first would
// strip the tag before that rewrite ever runs.
const HTML_START_RE =
  /^<\s*(?:!doctype\b|\/?(?:a|abbr|b|blockquote|body|br|caption|code|col|colgroup|dd|div|dl|dt|em|figcaption|figure|font|h[1-6]|head|hr|html|i|img|li|meta|ol|p|pre|s|section|small|span|strong|style|sub|sup|table|tbody|td|tfoot|th|thead|title|tr|u|ul)\b)/i;

export const looksLikeHTML = (str) =>
  typeof str === 'string' && HTML_START_RE.test(str.trimStart());
